import { useAuthStore } from '@/stores/authStore';
import Icon from '@/components/Icon';

/**
 * Shown when a user authenticates successfully but lacks the MagniBackofficeUser role
 * required to access the OpenBanking portal (e.g. a plain client employee). Mirrors the
 * MagniInbox "no permission" page. Public route — makes no API calls, so it can't loop.
 */
export function NoPermissionPage() {
  const { logout } = useAuthStore();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-500">
          <Icon name="gpp_bad" size={32} />
        </div>

        <h1 className="text-xl font-semibold text-gray-800 mb-2">Access Denied</h1>
        <p className="text-gray-600 mb-2">
          You don't have the required permissions to access the OpenBanking portal.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          Access requires the <span className="font-medium">MagniBackofficeUser</span> role. Please
          contact your organization's administrator to request it.
        </p>

        <div className="rounded-md bg-gray-50 border border-gray-100 p-4 text-left mb-6">
          <h2 className="text-sm font-semibold text-gray-700 mb-2">What should I do?</h2>
          <ul className="space-y-1.5 text-sm text-gray-600">
            <li className="flex gap-2"><span className="text-gray-400">•</span>Contact your organization's administrator or IT department</li>
            <li className="flex gap-2"><span className="text-gray-400">•</span>Request the MagniBackofficeUser role for the OpenBanking portal</li>
          </ul>
        </div>

        <button
          onClick={() => logout()}
          className="inline-flex items-center justify-center gap-2 w-full rounded-md bg-primary px-4 py-2 text-white font-medium hover:opacity-90 transition"
        >
          <Icon name="logout" size={18} />
          Sign out
        </button>
      </div>
    </div>
  );
}
